<template>
    <div style="min-height: calc(100vh - 158px);" class="card">
        <div style="background: #DBE7F2" class="card p-2">
            <TitleButton
                :showBtn="false"
                title="Trial Balance"
            />

            <div class="col-12 mt-2">
                <DateQuerySetter
                    btnTitle="Go"
                    @onClickGo="onClickGo"
                >
                    <div class="cols-12 col-sm-6 col-lg-4 col-xl-3" v-if="company && company.company_type === 'group'">
                        <label for="colFormLabel" class="col-form-label">Companies</label>
                        <AsyncSelect
                            placeholder="Companies"
                            v-model="companyIds"
                            :api-service="fetchCompaniesDropdown"
                            label="name"
                            :multiple="true"
                        />
                    </div>
                </DateQuerySetter>
            </div>
        </div>

        <div class="col-12">
            <div class="d-flex justify-content-end px-2">
                <button 
                    @click="exportTable"
                    class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
                >
                    Export
                </button>
            </div>
        </div>

        <div class="card mt-1 px-2">
            <TrialBalanceTable :balances="trialBalanceData"/>
        </div>
        <Loader v-if="reportLoading"/>
    </div>
</template>

<script>
import handleReport from '@/services/modules/accountingReport'
import { inject } from 'vue'

import TitleButton from '@/components/atom/TitleButton'
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import TrialBalanceTable from '@/components/molecule/company/trial-balance/TrialBalanceTable'
import Loader from '@/components/atom/LoaderComponent'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleCompany from "@/services/modules/company";
import handleAccounting from "@/services/modules/accounting";

export default {
    name: 'TrialBalance',

    components: {
        AsyncSelect,
        TitleButton,
        Loader,
        DateQuerySetter,
        TrialBalanceTable
    },

    data: () => ({
        trialBalanceData: [],
        company: null,
        companyIds: [],
    }),

    computed: {
        companyId() {
            return this.$route.params.companyId
        },
        start() {
            return this.$route.query.start
        },
        end() {
            return this.$route.query.end
        },
        token () {
            return localStorage.getItem('token')
        }
    },

    methods: {
        onClickGo() {
            this.getDateWiseTrailBalance(this.getQuery())
        },

        exportTable () {
            let url = `${process.env.VUE_APP_BASE_URL}/export/accounting/trial-balance?company_id=${this.companyId}&start_date=${this.start}&end_date=${this.end}&_token=${this.token}`
            let a = document.createElement("a")
            a.setAttribute("href", url)
            a.click()
        },

        getQuery () {
            let query = '?company_id=' + this.companyId
            if(!this.start && !this.end) return query
            if(this.start) query += '&start_date='+this.start
            if(this.end) query += '&end_date='+this.end
            if (Array.isArray(this.companyIds) && this.companyIds.length) {
                this.companyIds.forEach(company => {
                    query += `&company_ids[]=${company.id}`
                })
            }
            return query
        },

        async getDateWiseTrailBalance(query = '') {
            try {
                this.reportLoading = true
                let res = await this.getTrialBalance(query)
                if(!res.status) {
                    this.showError(res.response.message)
                }
                if(res.status) {
                    this.trialBalanceData = res.data
                }
            } catch (err) {
                if(!err.response) {
                    this.showError('Something is wrong. Check your connectivity!!')
                }
                if(err.response?.data) {
                    this.showError(err.response.data.message)
                    return
                }
            } finally {
                this.reportLoading = false
            }
        },
        getCompany() {
            this.fetchCompanyInfo(this.companyId)
                .then((res) => {
                    if(res.status){
                        this.company = res.data;
                    }
                }).catch((error) => {
                console.log(error);
            });
        },
    },

    setup() {
        const showError =  inject('showError');
        const showSuccess =  inject('showSuccess');
        // const store = useStore()
        const {
            getTrialBalance,
            reportLoading,
            getLedger
        } = handleReport()


        const {fetchCompanyInfo} = handleCompany();
        const {fetchCompaniesDropdown} = handleAccounting()


        return {
            fetchCompaniesDropdown,
            fetchCompanyInfo,
            getTrialBalance,
            reportLoading,
            showSuccess,
            showError,
            getLedger,
        }
    },

    mounted () {
        this.getDateWiseTrailBalance(this.getQuery())
        this.getCompany()
    }

}
</script>